/**
 * 模块说明：大目录管理
 */
import { Service } from '@/tools'
export class OrderServer<T extends TOrder.OrderApiType> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.OrderApiType}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  private upload2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TOrder.OrderApiType}`, data?: TCommon.Json, toast?: string) {
    return this.upload(url, data, toast)
  }

  /**
   * 功能：中小学教材订单新增
   * /api/order/v1/addTextbookOrder
   */
  textbook = <K extends T['ApiTextbook']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiTextbook', data)
  /**
   * 功能：教材销售管理-省店业务-列表查询
   * /api/order/v1/provincialStoreOrderList
   */
  provincialStoreOrderList = <K extends T['ApiProvincialStoreOrderList']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiProvincialStoreOrderList', data)
  /**
   * 功能：教材销售管理-省店业务-详情-销售商品信息-展开
   * /api/order/v1/provincialStoreOrderProductList
   */
  provincialStoreOrderProductList = <K extends T['ApiProvincialStoreOrderProductList']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiProvincialStoreOrderProductList', data)
  /**
   * 功能：中小学教材订单新增校验
   * /api/order/v1/addTextbookOrderCheck
   */
  addTextbookOrderCheck = <K extends T['ApiAddTextbookOrderCheck']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiAddTextbookOrderCheck', data)
  /**
   * 功能：中小学教材订单新增
   * /api/order/v1/addTextbookOrder
   */
  addTextbookOrder = <K extends T['ApiAddTextbookOrder']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddTextbookOrder', data)
  /**
   * 功能：中小学教材订单编辑
   * /api/order/v1/updateTextbookOrder
   */
  updateTextbookOrder = <K extends T['ApiUpdateTextbookOrder']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateTextbookOrder', data)
  /**
   * 功能：销售订单-撤销转采购需求单
   * /api/order/v1/revokeConvertProcureRequire
   */
  revokeConvertProcureRequire = <K extends T['ApiRevokeConvertProcureRequire']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiRevokeConvertProcureRequire', data)
  /**
   * 功能：销售订单-转采购需求单
   * /api/order/v1/convertProcureRequire
   */
  convertProcureRequire = <K extends T['ApiConvertProcureRequire']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiConvertProcureRequire', data)
  /**
   * 功能：订单了结
   * /api/order/v1/orderEnd
   */
  orderEnd = <K extends T['ApiOrderEnd']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiOrderEnd', data)
  /**
   * 功能：订单挂起、取消挂起
   * /api/order/v1/orderSuspend
   */
  orderSuspend = <K extends T['ApiOrderSuspend']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiOrderSuspend', data)
  /**
   * 功能：教材中小学基层店商品详情
   * /api/order/v1/secondary
   */
  secondary = <K extends T['ApiSecondary']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiSecondary', data)
  /**
   * 功能：销售订单-转采购需求单-聚合商品信息
   * /api/order/v1/aggregateProductsList
   */
  aggregateProductsList = <K extends T['ApiAggregateProductsList']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiAggregateProductsList', data)
  /**
   * 功能：销售订单-教材省店商品详情
   * /api/order/v1/province
   */
  getProvince = <K extends T['ApiProvince']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiProvince', data)

  /**
   * 功能：省店教材订单新增
   * /api/order/v1/addSecondaryOrder
   */
  addSecondaryOrder = <K extends T['ApiAddSecondaryOrder']>(data?: K['req']): Promise<K['res']> => this.post2('v1/ApiAddSecondaryOrder', data)
  /**
   * 功能：省店教材订单添单
   * /api/order/v1/addSecondaryAppendOrder
   */
  addSecondaryAppendOrder = <K extends T['ApiAddSecondaryAppendOrder']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiAddSecondaryAppendOrder', data)
  /**
   * 功能：省店教材订单添单
   * /api/order/v1/updateSecondaryOrder
   */
  updateSecondaryOrder = <K extends T['ApiUpdateSecondaryOrder']>(data?: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUpdateSecondaryOrder', data)

  /**
   * 教材销售管理-省店业务-新建-编辑
   * /api/order/v1/addOrderProvincialOutlet
   */

  addOrderProvincialOutlet = <K extends T['ApiAddOrderProvincialOutlet']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAddOrderProvincialOutlet', data)
  }

  /**
   * 教材销售管理-省店业务-详情-基本信息
   * /api/order/v1/provincialStoreOrderDetails
   */
  provincialStoreOrderDetails = <K extends T['ApiProvincialStoreOrderDetails']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreOrderDetails', data)
  }
  /**
   * 教材销售管理-省店业务-了结
   * /api/order/v1/provincialStoreOrderOver
   */
  provincialStoreOrderOver = <K extends T['ApiProvincialStoreOrderOver']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreOrderOver', data)
  }
  /**
   * 教材销售管理-省店业务-挂起-取消挂起
   * /api/order/v1/provincialStoreOrderSuspend
   */
  provincialStoreOrderSuspend = <K extends T['ApiProvincialStoreOrderSuspend']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreOrderSuspend', data)
  }
  /**
   * 教材销售管理-省店业务-详情-销售商品信息-展开
   * /api/order/v1/provincialStoreCountOrderProductList
   */
  provincialStoreCountOrderProductList = <K extends T['ApiProvincialStoreCountOrderProductList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreCountOrderProductList', data)
  }
  /**
   *省店教材销售管理-关联目录-关联目录期号
   * /api/order/v1/provincialStoreAssociationDirectoryCode
   */
  provincialStoreAssociationDirectoryCode = <K extends T['ApiProvincialStoreAssociationDirectoryCode']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreAssociationDirectoryCode', data)
  }
  /**
   * 省店批发团购-列表查询
   * /api/order/v1/provincialStoreWholesalePurchasesOrderList
   */
  provincialStoreWholesalePurchasesOrderList = <K extends T['ApiProvincialStoreWholesalePurchasesOrderList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesOrderList', data)
  }
  /**
   * 省店批发团购-详情-销售商品信息
   * /api/order/v1/provincialStoreWholesalePurchasesOrderProductList
   */
  provincialStoreWholesalePurchasesOrderProductList = <K extends T['ApiProvincialStoreWholesalePurchasesOrderProductList']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesOrderProductList', data)
  }
  /**
   * 省店批发团购-新建
   * /api/order/v1/addOrderProvincialStoreWholesalePurchase
   */
  addOrderProvincialStoreWholesalePurchases = <K extends T['ApiAddOrderProvincialStoreWholesalePurchases']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiAddOrderProvincialStoreWholesalePurchases', data)
  }
  /**
   * 省店批发团购-详情-配送信息
   */
  provincialStoreWholesalePurchasesDeliveryList = <K extends T['ApiProvincialStoreWholesalePurchasesDeliveryList']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesDeliveryList', data)
  }
  /**
   * 省店批发团购-转采购需求单
   */
  provincialStoreWholesalePurchasesConvertProcureRequire = <K extends T['ApiProvincialStoreWholesalePurchasesConvertProcureRequire']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesConvertProcureRequire', data)
  }
  /**
   * 省店批发团购-转采购需求单-聚合商品信息
   * /api/order/v1/provincialStoreWholesalePurchasesAggregateProductsList
   */
  provincialStoreWholesalePurchasesAggregateProductsList = <K extends T['ApiProvincialStoreWholesalePurchasesAggregateProductsList']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesAggregateProductsList', data)
  }
  /**
   * 省店批发团购-详情-基本信息
   * /api/order/v1/provincialStoreWholesalePurchasesOrderDetails
   */
  provincialStoreWholesalePurchasesOrderDetails = <K extends T['ApiProvincialStoreWholesalePurchasesOrderDetails']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesOrderDetails', data)
  }
  /**
   * 省店批发团购-查询移动加权平均-列表
   * /api/order/v1/pageSettleGoodsInventoryList
   */
  pageSettleGoodsInventoryList = <K extends T['ApiPageSettleGoodsInventoryList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiPageSettleGoodsInventoryList', data)
  }
  /**
   * 省店批发团购-关闭
   * api/order/v1/provincialStoreOrderClose
   */
  provincialStoreOrderClose = <K extends T['ApiProvincialStoreOrderClose']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreOrderClose', data)
  }
  /**
   *省店批发团购-文件-上传回告
   /api/order/v1/provincialStoreFileUploadReport
   */
  provincialStoreFileUploadReport = <K extends T['ApiProvincialStoreFileUploadReport']>(data: K['req']): Promise<K['res']> => {
    return this.upload2('v1/ApiProvincialStoreFileUploadReport', data)
  }
  /**
   * 省店批发团购-导出
   * /api/order/v1/provincialStoreWholesalePurchasesOrderListExport
   */
  provincialStoreWholesalePurchasesOrderListExport = <K extends T['ApiProvincialStoreWholesalePurchasesOrderListExport']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesalePurchasesOrderListExport', data, 'blob')
  }
  /***
   *省店批发团购-接口-上传回告
   /api/order/v1/provincialStoreInteUploadReport
   */
  provincialStoreInteUploadReport = <K extends T['ApiProvincialStoreInteUploadReport']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreInteUploadReport', data)
  }
  /**
   *省店批发团购-下载回告模版
   * /api/order/v1/provincialStoreDownloadReport
   */
  provincialStoreDownloadReport = <K extends T['ApiProvincialStoreDownloadReport']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreDownloadReport', data, 'blob')
  }

  /**省店批发团购-关联预留单
   *provincialStoreRelevancyReserveOrder
   */
  provincialStoreRelevancyReserveOrder = <K extends T['ApiProvincialStoreRelevancyReserveOrder']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreRelevancyReserveOrder', data)
  }

  /**
   * 客户查询授权情况
   */
  getCustomerCreditByCustomerCode = <K extends T['ApiGetCustomerCreditByCustomerCode']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiGetCustomerCreditByCustomerCode', data)
  }
  /**
   *省店批发团购-详情-效期批次信息
   /api/order/v1/provincialStoreWholesaleExpirationBatchList
   */
  provincialStoreWholesaleExpirationBatchList = <K extends T['ApiProvincialStoreWholesaleExpirationBatchList']>(
    data: K['req']
  ): Promise<K['res']> => {
    return this.post2('v1/ApiProvincialStoreWholesaleExpirationBatchList', data)
  }
  /**
   *结算使用-查询销售列表
   /api/order/v1/querySettleOrderList
   */
  querySettleOrderList = <K extends T['ApiquerySettleOrderList']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiquerySettleOrderList', data)
  }
  /**
   * /api/order/v1/orderApprovalAggr
   * 销售订单-审批
   */
  orderApprovalAggr = <K extends T['ApiOrderApprovalAggr']>(data: K['req']): Promise<K['res']> => {
    return this.post2('v1/ApiOrderApprovalAggr', data)
  }
}
